<template>
  <div id="place-bet" >
       
    <table class="bet-form" align="center">
        <tr>
            <td colspan="4" class= "balance-row">
                <div style="display: inline-block;"><h1>Balance: {{formatCurrency(currentBalance.total)}} </h1></div>
            </td>
        </tr>
        <br/>
        <tr>
            <td class="input-title">
                <a>Option: </a>
            </td>
            <td class="input-values">
                <comboBox id="bet-option" v-bind:options="options" v-bind:selected="selected" v-bind:placeholder="placeholder" v-on:updateOption="updateOption($event)"></comboBox>
            </td>
        </tr>
        <br>
        <tr>
            <td class="input-title">
                 <a>Amount: </a>
            </td>
            <td class="input-values">
                <div style="display: inline-block;">
                    <div @click="valueDown" class='value-btn'>
                        <img :src="require(`../assets/arrow-down.svg`)" class="value-btn-img" />
                    </div>
                    <div style="display: inline-block; vertical-align: super;">
                        <input type="text" placeholder="Enter Number" id="bet-amount" v-model="bet_placed" @keypress="betChanged($event)"/>
                    </div>
                    <div @click="valueUp" class='value-btn'>
                        <img :src="require(`../assets/arrow-up.svg`)" class="value-btn-img"/>
                    </div>
                </div>
            </td>
        </tr>
        <br/>
    </table>
    <br>
    <div style="width: 100%;">
        <sliderConrol class="slider-conrol" v-on:persChange="persChange($event)" v-bind:value="pers"></sliderConrol>
    </div>
    <br>
    <button-a v-bind:button_status="valid_amount*valid_option*callFree" v-on:clicked="callPlaceBet" style="font-size: 40px; padding: 8px;">{{button_value}}</button-a>
  </div>
</template>
<script>
import sliderConrol from './Slider-Conrol'
import comboBox from './Combo-Box'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      pers: 0,
      bet_placed: '',
      placeholder: 'Choose an option',
      selected: {id: undefined, name: undefined},
      valid_amount: false,
      valid_option: false,
      button_value: 'Place Bet'
    }
  },
  computed: Object.assign(mapState([
    'currentBalance',
    'callFree'
  ])),
  props:
    ['options'],

  components: {
    sliderConrol,
    comboBox
  },
  methods: {
    persChange (val) {
      this.bet_placed = Math.floor(this.currentBalance.total * (val / 100))
    },
    betChanged (evt) {
      evt = (evt) || window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    updateOption (evt) {
      this.selected = evt
    },
    callPlaceBet () {
      this.$emit('callPlaceBet', this.bet_placed, this.selected.name)
    },
    valueUp () {
      const valDigits = this.bet_placed.toString().length
      this.bet_placed = parseFloat(this.bet_placed) + Math.pow(10, valDigits - 1)
    },
    valueDown () {
      const valDigits = this.bet_placed.toString().length
      this.bet_placed = parseFloat(this.bet_placed) - Math.pow(10, valDigits - 1)
    }
  },
  watch: {
    bet_placed: function (val) {
      val = parseFloat(val)
      if (val > parseFloat(this.currentBalance.total)) {
        this.persChange(100)
        this.pers = 100
      } else {
        this.pers = Math.floor((val / parseFloat(this.currentBalance.total)) * 100)
        console.log(this.pers)
      }
      this.valid_amount = true
      if (val < 1) {
        this.valid_amount = false
      }
    },
    selected: function (val) {
      if (val.name) {
        this.valid_option = true
        console.log(this.valid_option)
      }
    },
    callFree: function () {
      if (this.callFree) {
        this.button_value = 'Place Bet'
        document.getElementsByClassName('balance-row')[0].classList.add('pulse')
      } else {
        document.getElementsByClassName('balance-row')[0].className = 'balance-row'
        this.button_value = 'Processing'
      }
    }
  },
  created () {
    this.bet_placed = Math.floor(parseFloat(this.currentBalance.total) / 10)
  }
}
</script>
<style scoped>
    #place-bet{
      padding-bottom: 10px;
     border-top: 2px rgb(82, 82, 82) solid;
     border-bottom: 2px rgb(82, 82, 82) solid;
     width: 100%;
     display: inline-block;
     background-color: rgba(0, 0, 0, 0.2);
     
    }
    td{
        height: 50px;
        background-color: rgba(0, 0, 0, 0.4);
    }
    .balance-row{
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 10px;
        border: 2px var(--sl-red) solid;
    }
    .balance-row.pulse {
      animation-name: pulseWhite;
      animation-duration: 0.5s;
    }
    .bet-form{
        width: 80%;
        padding: 10px;
    }
  .input-values{
      width: 80%;
      color: white;
      font-size: 20px;
      height: 50px;
  }
  .slider-conrol{
      width: 80%;
      display: inline-block;
  }
  .value-btn-img {
    width: 35px;
    vertical-align: middle;
    padding-bottom: 5px;
  }
  #bet-amount{
      width: 100%;
      height: 100%;
      font-size: 20px;
      border-radius: 4px;
      color: white;
      background-color: rgba(0, 0, 0, 0);
      border: none;
      text-align: center;
  }
  #bet-amount:focus{
      outline: none;
  }
  #bet-option{
      min-width: 200px;
  }
  .input-title{
      font-size: 20px;
      font-weight: bold;
      text-align: center;
        border-radius: 10px;
        background-color: var(--sl-red);
  }
    .value-btn{
    display: inline-block;
    width: 70px;
    height: 100%;
    background-color:
    var(--sl-red);
    border-radius: 6px;
    font-size: 40px;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -o-user-select: none;
  }
  
  @keyframes pulseWhite{
  0%{
    background-color: white;
  }
  100%{
    background-color: rgba(0, 0, 0,0);
  }
}
  
</style>



// WEBPACK FOOTER //
// src/components/Place-Bet.vue